import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core'
import { FormBuilder } from '@angular/forms'
import { FieldsEditorActionManagerService } from '../../fields-editor/fields-editor-action-manager.service'
import { FieldPlaceholderComponent } from '../field-placeholder.component'
import { SignFieldState } from '../sign-field-state.model'
import { AuthService } from '@tv3/services/auth.service'
import { userFullname } from '@tokeet-frontend/tv3-platform'
import { SignFieldType } from '@tokeet-frontend/signature'

@Component({
  selector: 'app-prefill-field-placeholder',
  templateUrl: './prefill-field-placeholder.component.html',
  styleUrls: ['./prefill-field-placeholder.component.scss', '../global-fields.scss'],
})
export class PrefillFieldPlaceholderComponent extends FieldPlaceholderComponent {
  type = SignFieldType.Prefill

  @Input() label: string
  @Input() icon = 'far fa-user'
  @Input() prefillType = 'user'

  get fieldValue() {
    return this.form.get('value').value
  }

  constructor(
    private auth: AuthService,
    render: Renderer2,
    fb: FormBuilder,
    elementRef: ElementRef,
    actionManager: FieldsEditorActionManagerService
  ) {
    super(render, fb, elementRef, actionManager)
  }

  patchInitialData(data: SignFieldState) {
    data.readonly = true
    if (this.prefillType === 'user' && !data.value) {
      data.value = userFullname(this.auth.user)
      data.attributes = {
        ...data.attributes,
        prefill_type: this.prefillType,
        prefill_data_id: this.auth.user.id,
      }
    }
  }
}
